// extracted by mini-css-extract-plugin
export default {"applicants":"NoOfApplicantsComponent_applicants__jhL+t","filled":"NoOfApplicantsComponent_filled__Q-EIg"};